import { StateCreator } from 'zustand'

import { StoreState, useStore } from '.'

export interface Visibility {
  visibilityStatus: {
    [id: string]: boolean
  }
  setVisibility: (id: string, isVisible: boolean) => void
}

export interface VisibilitySlice {
  visibility: Visibility
}

// eslint-disable-next-line func-style
export const initVisibilitySlice: StateCreator<StoreState, [], [], VisibilitySlice> = (set) => ({
  visibility: {
    visibilityStatus: {},
    setVisibility: (id, isVisible) => {
      set((state) => ({
        visibility: {
          ...state.visibility,
          visibilityStatus: {
            ...state.visibility.visibilityStatus,
            [id]: isVisible,
          },
        },
      }))
    },
  },
})

export interface PersistedVisibilitySlice {
  visibility: {
    visibilityStatus?: {
      [id: string]: boolean
    }
  }
}

export function persistVisibilitySlice(state: StoreState): PersistedVisibilitySlice {
  return {
    visibility: {
      visibilityStatus: state.visibility.visibilityStatus,
    },
  }
}

interface UseVisibilityResults {
  isVisible: boolean
  setVisibility: (isVisible: boolean) => void
}

export function useVisibility(id: string): UseVisibilityResults {
  const { visibilityStatus, setVisibility } = useStore((state) => state.visibility)

  return {
    isVisible: visibilityStatus[id] ?? true,
    setVisibility: (isVisible: boolean) => {
      setVisibility(id, isVisible)
    },
  }
}
